import createGetProductsQuery from '../queries/createProductsQuery'

export default function queryProducts(store) {
  return store.getters.getGraphQLClient().query({
    query: createGetProductsQuery(),
    opName: 'getProducts'
  })
}
